import { Stack } from '@mui/material';
import { FlowDurationUnits } from 'flow-schema';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../../ConfigFields/Duration';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

import GetJobContextMode = api.RpaJob.GetJobContextMode;

export function JobContextFormFields() {
  const { value: mode = GetJobContextMode.FindAll } =
    useSelectedNodeField<api.RpaJob.GetJobContextMode>('config.mode');

  return (
    <Stack gap={3}>
      <BlockRadioGroupField
        fieldName="config.mode"
        label="Mode"
        row
        defaultValue={GetJobContextMode.FindAll}
        options={[
          {
            label: 'Find all using filters',
            value: GetJobContextMode.FindAll,
          },
          {
            label: 'Get one by RPA Job ID',
            value: GetJobContextMode.GetOneById,
          },
        ]}
      />

      {mode === GetJobContextMode.GetOneById && (
        <BlockValueTemplateField
          fieldName="config.rpaJobId"
          label="RPA Job ID"
          helperText="Enter the reference to the RPA Job ID. e.g. `{{start.data.entity.rpaJobId}}`"
          placeholder="e.g. {{start.data.entity.rpaJobId}}"
        />
      )}

      {mode === GetJobContextMode.FindAll && (
        <>
          <BlockSelectField
            label="Filter by Success Status"
            fieldName="config.successFilter"
            options={[
              { label: 'All', value: api.RpaJob.RpaJobSuccessFilter.All },
              { label: 'Failed Only', value: api.RpaJob.RpaJobSuccessFilter.FailedOnly },
              { label: 'Successful Only', value: api.RpaJob.RpaJobSuccessFilter.SuccessOnly },
            ]}
          />

          <BlockSelectField
            label="Job Kind"
            fieldName="config.jobKind"
            required
            options={Object.entries(api.RpaJob.Kind)
              .map(([key, value]) => ({
                label: key,
                value,
              }))
              .sort((a, b) => a.label.localeCompare(b.label))}
          />

          <BlockDurationField
            variant="BlockValueTemplate"
            fieldName="config.lookbackDuration"
            unitFieldNameSuffix="units"
            allowedUnits={Object.values(FlowDurationUnits)}
            valueLabel="Lookback duration"
          />

          <BlockValueTemplateField
            fieldName="config.limit"
            label="Limit"
            helperText={`Limit the number of jobs to return. Max: ${api.FlowDefinition.MAX_JOB_CONTEXT_LIMIT}`}
            placeholder={String(api.FlowDefinition.MAX_JOB_CONTEXT_LIMIT)}
          />
        </>
      )}
    </Stack>
  );
}
